import React from 'react';
import CustomerContactInfoComp from './CustomerContactInfoComp';

const CustomerContactInfoFirstName = props =>
  (
<CustomerContactInfoComp
  {...props}
  autoComplete="given-name"
  errorMessages={{
    'field_is_required': 'The first name field is required',
    'field_is_invalid': 'Your first name is invalid',
  }}
  label="First Name"
  name="firstName"
/>
  );

export default CustomerContactInfoFirstName;
